module.exports = __webpack_public_path__ + "static/media/contact-logo-mobile.8fc3a82f.svg";